import { useState } from "@wordpress/element";

const { __ } = wp.i18n;

function TableEntidadesItem({ entidad }) {
  const [activeRow, setActiveRow] = useState(false);

  const toggleContent = (entidadId) => {
    setActiveRow(entidadId);
    const collapsible = document.querySelectorAll(`.table-row[data-id="row-${entidadId}"] .table-cell__collapsible`);
    collapsible.forEach(cell => {
      cell.classList.toggle('is-visible');
      // need to unset Active row on close
      if (!cell.classList.contains('is-visible')) {
        setActiveRow(false);
      }
    });
  }

  return (
    <div 
      className={`table-row ${activeRow === entidad.id ? 'active' : ''}`}
      key={entidad.id} 
      data-id={`row-${entidad.id}`}>
      <div className="table-cell table-cell__title">
        {entidad.title}
        <a className="table-cell__mobile-trigger" onClick={ (event) => { event.preventDefault(); toggleContent(entidad.id) } } href="#"></a>
      </div>
      
      <div className={`table-cell table-cell__email table-cell__collapsible`}>
        <span className="on-mobile label-mobile has-text-gray-125-color">
          {__('Email', 'bizum-website')}
        </span>
        {entidad.email ? (
          <a href={`mailto:${entidad.email}`}>{entidad.email}</a>
        ) : (
          '-'
        )}
      </div>
      
      <div className="table-cell table-cell__collapsible">
        <span className="on-mobile label-mobile">
          {__('Teléfono', 'bizum-website')}
        </span>
        {entidad.phone && entidad.phone.length ? entidad.phone : '-'}
      </div>

      <div className="table-cell table-cell__external-link table-cell__collapsible">
        {entidad.website ? (
          <a className="wp-button-link is-underlined has-icon has-icon-after has-button-link-black-500-color icon-arrow-up-right"
            href={entidad.website} target="_blank" rel="noreferrer nofollow">
            <span className="cta-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.92308 6H18M18 6V16.0769M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <span className="cta-title">
              { __('Sitio Web', 'bizum-website') }
            </span>
          </a>
        ) : '-'}
      </div>
    </div>
  )
}

export default TableEntidadesItem